import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/application-error-screen';

function ApplicationError() {
  return <Screen />;
}
export default ApplicationError;
